import moment, {now} from "jalali-moment";
import {DateObject} from "react-multi-date-picker";
import {ACCESS_TOKEN} from "../redux/action/type.action";

export const numOnKeyDown = (event) => {
    // console.log(event.which, "add something")
    if ((event.which !== 8 && event.which !== 9 && event.which !== 0) && ((event.which < 48 || event.which > 57) && ((event.which < 37 || event.which > 40)) && (event.which < 96 || event.which > 105))) {
        event.preventDefault();
    }

    if (["e", "E", "+", "-"].includes(event.key) && event.preventDefault()) {
        return false
    }
}

export const range = (start, stop, step = 1) =>
    Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step))

export const isActiveToBook = (selectedDate, time = '', format = 'YYYY-MM-DD') => {
    let today = new DateObject({
        date: new Date(),
        format: format
    });

    if (selectedDate > today.format(format))
        return true;

    if (selectedDate === today.format(format))
        return time?.trim() !== '' && time >= today.format('HH:mm');

    return false;
}

export const saveAccessToken = async (value) => {
    await localStorage.setItem(ACCESS_TOKEN, value)
};
export const getAccessToken = async () => localStorage.getItem(ACCESS_TOKEN);

export const sleep = ms => new Promise(
    resolve => setTimeout(resolve, ms)
);

export const scrollToTop = async (timeout = 200) => {
    // setTimeout(() => {
    // window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    await sleep(timeout)
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    // }, timeout);
}

export const limitString = (value, len = 12) => {
    if (value?.length <= len) return value;
    return value?.substring(0, len) + '...';
}


export const firstChild = (arr) => {
    return [...arr ?? []].shift();
}

export const lastChild = (arr) => {
    return [...arr ?? []].pop();
}


export const isValidMobile = (value) => {
    if (value.trim()?.length !== 11) return false;
    return value?.substring(0, 2) === '09';

}

export const isValidFullname = (value) => {
    return value.trim()?.length >= 3;
}

export const isValidAddress = (value) => {
    return value.trim()?.length >= 3;
}

export const isValidOtp = (value) => {
    return value.trim()?.length === 5;
}

export const isValidHour = (value) => {
    if (value < 0 && value > 24 && value.trim()) return false;
}

export const isValidNationalCode = (value) => {
    let strLen = value.trim()?.length;
    if (strLen < 8 || parseInt(value) === 0) {
        return false;
    }
    let nationalCodeArray = value.split('');

    let num9 = nationalCodeArray[9];
    // console.log("num9")
    // console.log(num9)
    let sumNationalCode = (nationalCodeArray[0] * 10) + (nationalCodeArray[1] * 9) + (nationalCodeArray[2] * 8) + (nationalCodeArray[3] * 7) + (nationalCodeArray[4] * 6) + (nationalCodeArray[5] * 5) + (nationalCodeArray[6] * 4) + (nationalCodeArray[7] * 3) + (nationalCodeArray[8] * 2);
    let divideNationalCode = Math.floor(sumNationalCode % 11);
    // console.log(divideNationalCode)
    return divideNationalCode < 2 && num9 === divideNationalCode || divideNationalCode >= 2 && num9 === Math.abs(11 - divideNationalCode);
}


export const upTo = (el, tagName, className = null) => {
    tagName = tagName.toLowerCase();

    while (el && el.parentNode) {
        el = el.parentNode;
        if (el.tagName && el.tagName.toLowerCase() === tagName && (el?.className?.indexOf(className) >= 0 || className === null)) {
            return el;
        }
    }

    // Many DOM methods return null if they don't
    // find the element they are searching for
    // It would be OK to omit the following and just
    // return undefined
    return null;
}
export const destroyElement = async (item, deleteCallback = null) => {
    if (!Boolean(item)) return false;
    // console.log(item)
    item.style.opacity = 1;
    let tmr = setInterval(() => {
        item.style.opacity = item.style.opacity - 0.05;
    }, 5);

    while (item.style.opacity > 0.2) {
        await sleep(20);
    }

    if (item.style.opacity <= 0.2) {
        clearInterval(tmr);
        // item.style.display = 'none'
    }

    // console.log('elm', 'end of destroy element')

    if (deleteCallback) await deleteCallback();
    await sleep(200)
    item.style.opacity = 1;
    // console.log('after delete callback')
}

export const whiteSpace = (count = 1) => {

    let out = "";
    for (let i = 0; i < count; i++) {
        out = out + "\u00A0"
    }
    return out;
}

export const isEven = (num) => {
    // num%2===0 ? true : false
    return num % 2 === 0;
};
export const logTable = (data) => {
    console.table(data)
};
export const log = (data) => {
    console.log(data)
};
export const logCount = (data) => {
    console.count(data)
}

export const deleteFromArray = (arr = [], value) => {
    let index = arr.findIndex(i => i === value);
    while (index >= 0) {
        arr.splice(index, 1);
        index = arr.findIndex(i => i === value);
    }
    return arr;
}

export const isEmpty = (mixedVar) => {
    let undef
    let key
    let i
    let len
    const emptyValues = [undef, null, false, 0, '', '0']

    for (i = 0, len = emptyValues?.length; i < len; i++) {
        if (mixedVar === emptyValues[i]) {
            return true
        }
    }

    if (typeof mixedVar === 'object') {
        for (key in mixedVar) {
            if (mixedVar.hasOwnProperty(key)) {
                return false
            }
        }
        return true
    }

    if (typeof mixedVar === 'string') {
        return mixedVar.trim()?.length === 0;
    }

    return false
}


export const validPassword = (value) => {
    let regularUpperCase = /(?=.*[A-Z])/;
    let regularLowerCase = /(?=.*[a-z])/;
    let regularNumber = /(?=.*[0-9])/;

    return (regularUpperCase.test(value) && regularLowerCase.test(value) && regularNumber.test(value) && value?.length >= 8)
}

export const isValidEmail = (value) => {
    if (!value) {
        return false;
    } else if (!/\S+@\S+\.\S+/.test(value)) {
        return false;
    }
    return true;
}


export const isValidPhone = (value) => {
    if (value.trim()?.length !== 11) return false;
    return value?.substring(0, 1) === '0';
}


export const getDurationTimeFrom = (jalaliDate, locale = 'fa', format = 'jYYYY-jMM-jDD HH:mm') => {
    let res = moment.from(jalaliDate, locale, format).diff(now(), 'second');
    // res = res.replaceAll('hours', 'ساعت')
    //     .replaceAll('hour', 'ساعت')
    //     .replaceAll('minutes', 'دقیقه')
    //     .replaceAll('minute', 'دقیقه')
    //     .replaceAll('seconds', 'ثانیه')
    //     .replaceAll('second', 'ثانیه')
    //     .replaceAll('months', 'ماه')
    //     .replaceAll('month', 'ماه')
    //     .replaceAll('days', 'روز')
    //     .replaceAll('day', 'روز')
    //     .replaceAll('years', 'سال')
    //     .replaceAll('year', 'سال')
    //     .replaceAll('in', '')
    //     .replaceAll('ago', '')
    //     .replaceAll('an', 'یک')
    //     .replaceAll('a', 'یک')

    return convertSecondsToTime(res);
}

export const convertSecondsToTime = (seconds) => {
    let suffix = seconds < 0 ? 'قبل' : 'بعد';
    seconds = seconds < 0 ? seconds * (-1) : seconds;
    let year = 0;
    let month = 0;
    let day = 0;
    let hour = 0;
    let minute = 0;

    while (seconds >= 31104000) {
        seconds -= 31104000;
        year++;
    }
    while (seconds >= 2592000) {
        seconds -= 2592000;
        month++;
    }

    while (seconds >= 86400) {
        seconds -= 86400;
        day++;
    }

    while (seconds >= 3600) {
        seconds -= 3600;
        hour++;
    }

    while (seconds >= 60) {
        seconds -= 60;
        minute++;
    }
    // if (hour <= 9) {
    //     hour = `0${hour}`;
    // }
    if (minute <= 9) {
        minute = `0${minute}`;
    }
    if (seconds <= 9) {
        seconds = `0${seconds}`;
    }

    // generate date
    let res = year > 0 ? `${year} سال و` : '';
    res += month > 0 ? `${month} ماه و` : '';
    if (year === 0)
        res += day > 0 ? `${day} روز و` : '';

    res = rtrim(res, 'و');

    // generate time
    let time = parseInt(hour) > 0 ? `${hour} ساعت و ` : '';
    time += parseInt(minute) > 0 ? `${minute} دقیقه ` : '';
    time = rtrim(time, ' و');

    return (res.trim() === '' ? time : res) + ' ' + suffix;
}
export const SecondsToTime = (seconds) => {

    let year = 0;
    let month = 0;
    let day = 0;
    let hour = 0;
    let minute = 0;

    while (seconds >= 31104000) {
        seconds -= 31104000;
        year++;
    }
    while (seconds >= 2592000) {
        seconds -= 2592000;
        month++;
    }

    while (seconds >= 86400) {
        seconds -= 86400;
        day++;
    }

    while (seconds >= 3600) {
        seconds -= 3600;
        hour++;
    }

    while (seconds >= 60) {
        seconds -= 60;
        minute++;
    }
    // if (hour <= 9) {
    //     hour = `0${hour}`;
    // }
    if (minute <= 9) {
        minute = `0${minute}`;
    }
    if (seconds <= 9) {
        seconds = `0${seconds}`;
    }

    return `${hour > 0 ? hour + ':' : ''} ${minute}:${seconds}`
}

export const makeTimeTwoNum = (timeStr, showSecond = false) => {
    if (isEmpty(timeStr)) return 'نامشخص'
    if (timeStr.trim()?.length < 1) return timeStr;
    let arr = timeStr?.trim()?.split(':');
    let res = '';
    arr?.map((i, x) => {
        if (!showSecond && x >= 2) return;
        res = res + (i?.length < 2 ? `0${i}:` : `${i}:`);
    })

    res = rtrim(res, ':');
    // console.log('rrrrrrrrrr',res)
    return res;
}


export const rtrim = (str, charlist) => {
    charlist = !charlist
        ? ' \\s\u00A0'
        : (charlist + '').replace(/([[\]().?/*{}+$^:])/g, '\\$1')
    const re = new RegExp('[' + charlist + ']+$', 'g')
    return (str + '').replace(re, '')
}


export const escapedNewLineToLineBreakTag = (string) => {
    return string?.replaceAll("\\n", "<br/>")?.replaceAll("\n", "<br/>")
}

export function nl2br(str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = '<br/>'; //(is_xhtml || typeof is_xhtml === 'undefined') ? '' : '<br/>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}


export const betweenRange = (start, end, value) => {
    if (value.trim() === '') return true;
    let intStart = parseInt(start);
    let intEnd = parseInt(end);
    let intValue = parseInt(value);

    return intStart <= intValue && intValue <= intEnd;
}

export const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const getRandomStr = (length = 8) => {
    return str_shuffle('abcdefghijklmnopqrstuvwxyz0123654789-', length)
}


export const remove_number_format = (str) => {
    return str_replace(',', '', str)
}

export const nonBreaking = (value, zero = true) => {
    return str_replace(' ', String.fromCharCode(zero ? 0 : 160), value)
}

export const number_format = (number, decimals, decPoint, thousandsSep) => {
    number = faToEnNum(number);
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    const n = !isFinite(+number) ? 0 : +number
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    const dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    let s = ''

    const toFixedFix = function (n, prec) {
        if (('' + n).indexOf('e') === -1) {
            return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
        } else {
            const arr = ('' + n).split('e')
            let sig = ''
            if (+arr[1] + prec > 0) {
                sig = '+'
            }
            return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
        }
    }

    // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
    if (s[0]?.length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '')?.length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1]?.length + 1).join('0')
    }

    return s.join(dec)
}

export const faToEnNum = (value) => {
    value = str_replace(['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'], ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], value);
    return str_replace(['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'], ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], value);
}

export const enToFaNum = (value) => {
    value = str_replace(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'], value);
    return str_replace(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'], value);

}

export const str_replace = (search, replace, subject, countObj) => {
    let i = 0
    let j = 0
    let temp = ''
    let repl = ''
    let sl = 0
    let fl = 0
    const f = [].concat(search)
    let r = [].concat(replace)
    let s = subject
    let ra = Object.prototype.toString.call(r) === '[object Array]'
    const sa = Object.prototype.toString.call(s) === '[object Array]'
    s = [].concat(s)

    const $global = (typeof window !== 'undefined' ? window : global)
    $global.$locutus = $global.$locutus || {}
    const $locutus = $global.$locutus
    $locutus.php = $locutus.php || {}

    if (typeof (search) === 'object' && typeof (replace) === 'string') {
        temp = replace
        replace = []
        for (i = 0; i < search?.length; i += 1) {
            replace[i] = temp
        }
        temp = ''
        r = [].concat(replace)
        ra = Object.prototype.toString.call(r) === '[object Array]'
    }

    if (typeof countObj !== 'undefined') {
        countObj.value = 0
    }

    for (i = 0, sl = s?.length; i < sl; i++) {
        if (s[i] === '') {
            continue
        }
        for (j = 0, fl = f?.length; j < fl; j++) {
            if (f[j] === '') {
                continue
            }
            temp = s[i] + ''
            repl = ra ? (r[j] !== undefined ? r[j] : '') : r[0]
            s[i] = (temp).split(f[j]).join(repl)
            if (typeof countObj !== 'undefined') {
                countObj.value += ((temp.split(f[j]))?.length - 1)
            }
        }
    }
    return sa ? s : s[0]
}

export const fixStringToTextView = (value) => {
    return value?.replaceAll('&zwnj;', '')
        ?.replaceAll('\\r\\n', '\r\n')
        ?.replaceAll('\\\\n', '\n')
        ?.replaceAll('\\n', '\n')
}

export const fixStringToHtml = (value) => {
    return value?.replaceAll('&zwnj;', '')
        ?.replaceAll('\\r\\n', '<br />')
        ?.replaceAll('\\\\n', '<br />')
        ?.replaceAll('\\n', '<br/>')
}

export const longString = (value, len = 12) => {
    if (value?.length <= len) return value;
    return value?.substring(0, len) + '...';
}

export const getDate = (date) => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month?.length < 2)
        month = '0' + month;
    if (day?.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

export const getMonthName = (m) => {
    let months = [
        '-',
        'فروردین',
        'اردیبهشت',
        'خرداد',
        'تیر',
        'مرداد',
        'شهریور',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند',
    ];

    return months[m >= 1 && m <= 12 ? m : 1]
}
export const toStringDate = (date, showYear = true) => {
    if (isEmpty(date)) return null;
    let arr = date.split(' ');
    let d = arr[0]?.split(date.includes('-') ? '-' : '/');

    let monthName = getMonthName(parseInt(d[1]));

    return `${d[2]} ${monthName} ` + (showYear ? d[0] : '') + (!isEmpty(arr[1]) ? '،ساعت ' + makeTimeTwoNum(arr[1]) : '');
}

export const setCookie = (cname, cvalue, exdays) => {
    let d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const getCookie = (cname) => {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca?.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c?.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c?.substring(name?.length, c?.length);
        }
    }
    return "";
}


export const str_shuffle = (str, length = 0) => {

    if (str === null) {
        return ''
    }

    str += ''

    let newStr = ''
    let rand
    let i = str?.length

    while (i) {
        rand = Math.floor(Math.random() * i)
        newStr += str.charAt(rand)
        str = str?.substring(0, rand) + str.substr(rand + 1)
        i--
    }

    if (length === 0) return newStr
    return newStr.substr(0, length - 1);
}


export const base64_encode = (stringToEncode) => {
    // encodeUTF8string()
    // Internal function to encode properly UTF8 string
    // Adapted from Solution #1 at https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
    const encodeUTF8string = function (str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into the base64 encoding algorithm.
        return encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1)
            })
    }

    if (typeof window !== 'undefined') {
        if (typeof window.btoa !== 'undefined') {
            return window.btoa(encodeUTF8string(stringToEncode))
        }
    } else {
        return new Buffer(stringToEncode).toString('base64')
    }

    const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    let o1
    let o2
    let o3
    let h1
    let h2
    let h3
    let h4
    let bits
    let i = 0
    let ac = 0
    let enc = ''
    const tmpArr = []

    if (!stringToEncode) {
        return stringToEncode
    }

    stringToEncode = encodeUTF8string(stringToEncode)

    do {
        // pack three octets into four hexets
        o1 = stringToEncode.charCodeAt(i++)
        o2 = stringToEncode.charCodeAt(i++)
        o3 = stringToEncode.charCodeAt(i++)

        bits = o1 << 16 | o2 << 8 | o3

        h1 = bits >> 18 & 0x3f
        h2 = bits >> 12 & 0x3f
        h3 = bits >> 6 & 0x3f
        h4 = bits & 0x3f

        // use hexets to index into b64, and append result to encoded string
        tmpArr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4)
    } while (i < stringToEncode?.length)

    enc = tmpArr.join('')

    const r = stringToEncode?.length % 3

    return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3)
}


export const base64_decode = (encodedData) => {
    const decodeUTF8string = function (str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(str.split('')?.map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
    }

    if (typeof window !== 'undefined') {
        if (typeof window.atob !== 'undefined') {
            return decodeUTF8string(window.atob(encodedData))
        }
    } else {
        return new Buffer(encodedData, 'base64').toString('utf-8')
    }

    const b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    let o1
    let o2
    let o3
    let h1
    let h2
    let h3
    let h4
    let bits
    let i = 0
    let ac = 0
    let dec = ''
    const tmpArr = []

    if (!encodedData) {
        return encodedData
    }

    encodedData += ''

    do {
        // unpack four hexets into three octets using index points in b64
        h1 = b64.indexOf(encodedData.charAt(i++))
        h2 = b64.indexOf(encodedData.charAt(i++))
        h3 = b64.indexOf(encodedData.charAt(i++))
        h4 = b64.indexOf(encodedData.charAt(i++))

        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4

        o1 = bits >> 16 & 0xff
        o2 = bits >> 8 & 0xff
        o3 = bits & 0xff

        if (h3 === 64) {
            tmpArr[ac++] = String.fromCharCode(o1)
        } else if (h4 === 64) {
            tmpArr[ac++] = String.fromCharCode(o1, o2)
        } else {
            tmpArr[ac++] = String.fromCharCode(o1, o2, o3)
        }
    } while (i < encodedData?.length)

    dec = tmpArr.join('')

    return decodeUTF8string(dec.replace(/\0+$/, ''))
}